import React, { useState, useEffect, useCallback , useRef  } from 'react';
import Navbar from "../component/Navbar";
import Card from "react-bootstrap/Card";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";
import Button from "react-bootstrap/Button";
import { useNavigate , useLocation } from 'react-router-dom';
import Modal from 'react-bootstrap/Modal';
import { QRCodeSVG } from 'qrcode.react';
import PatientInfo from '../component/PatientInfo';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import Ipserver from '../ipserver'
// Images
import CopyB from "../img/copyicon-black.png";
import CopyW from "../img/copyicon-white.png";
import qrcodebutton from "../img/qrcodebutton.png";
import Backbutton from "../img/backbutton.png";
import Videobutton from "../img/videobutton.png";
import Shareicon from "../img/shareicon.png";
import Saveicon from "../img/saveicon.png";
import "../css/Teleinfo.css";
import { useLogin } from '../component/LoginContext';
let socket;

const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const Teleinfo = () => {
    const {passCode} = useLogin();
    const location = useLocation();
    const [imgSrc, setImgSrc] = useState(CopyB);
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [copyText, setCopyText] = useState('');
    const [roomId, setRoomId] = useState(null);
    const [error, setError] = useState(null);
    const navigate = useNavigate();
    const ip = Ipserver;
    const [showModals, setShowModals] = useState(false);
    const handleModalClose = () => setShowModals(false);
    const handleModalShow = () => setShowModals(true);
    const [ shareColorQR , setShareColorQR ] = useState(true);
    const [ saveColorQR , setSaveColorQR ] = useState(true);

    const patient = location.pathname.split('/').pop();
    // ปุ่มย้อนกลับ
    const handleNavigateBack = () => {
        navigate(`/worklist/${passCode.passCode}`);
    };

    //ปุ่มไปห้องพูดคุย
    const handleNavigateVideo = () => {
        if (roomId) {
            navigate(`/telemedicine/${roomId}/${patient}`);
        } else {
            setError('Room is not created yet. Please wait.');
            setSnackbarOpen(true);
        }
    };

    // ปุ่มคัดลอกลิงค์
    const handleCopy = () => {
        const textarea = document.createElement('textarea');
        textarea.value = copyText;
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand('copy');
        document.body.removeChild(textarea);

        setSnackbarOpen(true);
        if (socket) {
            socket.emit('copyLink', copyText);
        }
    };

    // แสดง Snackbar ของการ CopyLink
    const handleSnackbarClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setSnackbarOpen(false);
    };

    // สร้างลิงค์ห้องพูดคุย
    const generateRoomLink = useCallback(async () => {
        try {
            const response = await fetch(`https://${ip}/api/create-room`);
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            const data = await response.json();
            const newRoomId = data.roomId;
            setRoomId(newRoomId);
            
            const link = `${window.location.origin}/#/telemedicine/${newRoomId}/${patient}`;
            setCopyText(link);
        } catch (error) {
            console.error('Error fetching room ID:', error);
            setError('Failed to create room. Please try again.');
            setSnackbarOpen(true);
        }
    }, []);

    
    useEffect(() => {

        
        if (!roomId) {
            generateRoomLink();
        }

        return () => {
            if (socket) {
                socket.off('copyLink');
                socket.off('connect_error');
            }
        };
    }, [generateRoomLink, roomId]);


    const qrCodeRef = useRef();
    const downloadQR = () => {
      const svgElement = qrCodeRef.current.querySelector("svg"); // ดึง SVG ภายใน QRCode
      if (!svgElement) {
        console.error("SVG element not found");
        return;
      }
    
      const serializer = new XMLSerializer();
      const svgString = serializer.serializeToString(svgElement);
      
      const canvas = document.createElement("canvas");
      const context = canvas.getContext("2d");
    
      const svgSize = svgElement.getBoundingClientRect();
      const QRSize = 3.7; 
      // กำหนดขนาด canvas ให้ใหญ่ขึ้นตาม QRSize
      
      canvas.width = 500;
      canvas.height = 500;
      const img = new Image();
      const svgBlob = new Blob([svgString], { type: "image/svg+xml;charset=utf-8" });
      const url = URL.createObjectURL(svgBlob);
      img.onload = () => {
        // ตั้งค่า background สีขาวสำหรับ QR code
        context.fillStyle = "#ffffff";
        context.fillRect(0, 0, canvas.width, canvas.height);
    
        context.scale(QRSize, QRSize);
        context.drawImage(img, QRSize, QRSize);
        URL.revokeObjectURL(url);
    
        const pngUrl = canvas
          .toDataURL("image/png")
          .replace("image/png", "image/octet-stream");
    
        let downloadLink = document.createElement("a");
        downloadLink.href = pngUrl;
        downloadLink.download = "QRCode.png";
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
      };
    
      img.src = url;
    };
    

    const shareQR = async () => {
        if(navigator.share){
            try{
                await navigator.share({
                    title: 'Video Call',
                    text: 'Video call with doctor.',
                    url: copyText,
                });
            }catch(err){
                console.error('Error sharing context:',err);
            }
        } else {
            alert('Web Share API is not supported in this browser');
        }
    };

    const changeShareColorQR = () => {
        setShareColorQR(!shareColorQR);
    }

    const changeSaveColorQR = () => {
        setSaveColorQR(!saveColorQR);
    }
    
    return (
        <>
            <Modal show={showModals} onHide={handleModalClose} centered>
                <Modal.Header>
                    <Modal.Title>Data</Modal.Title>
                </Modal.Header>
                <Modal.Body className='d-flex align-items-center justify-content-center'>
                    <div ref={qrCodeRef}>
                        <QRCodeSVG className="modalqrcode" value={copyText} />
                    </div>
                </Modal.Body>
                <Modal.Footer className='d-flex align-items-center justify-content-center'>
                    <div>

                        <a href='#'  onClick={(e) => {e.preventDefault();shareQR();} } onMouseEnter={changeShareColorQR} onMouseLeave={changeShareColorQR}  >
                            <img className= {shareColorQR ? 'ssbutton qrfcolor me-5' : 'ssbutton qrscolor me-5'}  src={Shareicon} alt="Share" />
                        </a>
                        
                        <a href='#' onMouseEnter={changeSaveColorQR} onMouseLeave={changeSaveColorQR} onClick={(e) => {e.preventDefault();downloadQR();}}>
                            <img  className={saveColorQR ? 'ssbutton qrfcolor ' : 'ssbutton qrscolor '} src={Saveicon} alt="Save" />
                        </a>

                    </div>
                </Modal.Footer>
            </Modal>

            <Navbar />
            <PatientInfo />

            <Card className="mt-3 cardworklist">
                <Card.Body className='generatelinkcard'>
                    <h4 className="datapatientheader">Generate Link Video</h4>
                    <hr />

                    <div className='d-flex align-items-center urlgroup justify-content-center mt-4'>
                        <InputGroup className="mt-3 urlcopy justify-content-center d-flex">
                            <Form.Control
                                className='blockinput'
                                value={copyText}
                                readOnly
                            />
                            <Button
                                className="copybutton"
                                onClick={handleCopy}
                                onMouseEnter={() => setImgSrc(CopyW)}
                                onMouseLeave={() => setImgSrc(CopyB)}
                            >
                                <img className="copyurliconw" src={imgSrc} alt="copy" />
                                คัดลอก
                            </Button>
                        </InputGroup>

                        <Button className='QRbutton ms-3' onClick={handleModalShow}>
                            <img className='copyurliconw' src={qrcodebutton} alt='qrbutton' />
                            QR CODE
                        </Button>
                    </div>

                    <div className='d-flex align-items-center mt-4 justify-content-center'>
                        <Button className='backbutton me-3' onClick={handleNavigateBack}>
                            <img className='backbuttonimg me-2' src={Backbutton} alt="Back" />ย้อนกลับ
                        </Button>
                        <Button className='videobutton' onClick={handleNavigateVideo} disabled={!roomId}>
                            <img className='backbuttonimg me-2' src={Videobutton} alt="Video" />
                            {roomId ? 'ไปที่ห้องวิดีโอคอล' : 'กำลังสร้างห้อง...'}
                        </Button>
                    </div>

                    <Snackbar open={snackbarOpen} autoHideDuration={3000} onClose={handleSnackbarClose}>
                        <Alert onClose={handleSnackbarClose} severity={error ? "error" : "success"}>
                            {error || "Copied!"}
                        </Alert>
                    </Snackbar>
                </Card.Body>
            </Card>
        </>
    );
};

export default Teleinfo;